import { NativeModules } from 'react-native';

const { RNZoomVideoSdkUserHelper } = NativeModules;

/**
 * User control interface.
 */
export type ZoomVideoSdkUserHelperType = {
  /**
   * Change a specific user's name.
   */
  changeName: (name: string, userId: string) => Promise<boolean>;

  /**
   * Assign a user as the session host.
   */
  makeHost: (userId: string) => Promise<boolean>;

  /**
   * Assign a user as the session manager.
   */
  makeManager: (userId: string) => Promise<boolean>;

  /**
   * Revoke manager rights from a user.
   */
  revokeManager: (userId: string) => Promise<boolean>;

  /**
   * Remove user from session.
   */
  removeUser: (userId: string) => Promise<boolean>;
};

export class ZoomVideoSdkUserHelper implements ZoomVideoSdkUserHelperType {
  async changeName(name: string, userId: string) {
    return await RNZoomVideoSdkUserHelper.changeName(name, userId);
  }

  async makeHost(userId: string) {
    return await RNZoomVideoSdkUserHelper.makeHost(userId);
  }

  async makeManager(userId: string) {
    return await RNZoomVideoSdkUserHelper.makeManager(userId);
  }

  async revokeManager(userId: string) {
    return await RNZoomVideoSdkUserHelper.revokeManager(userId);
  }

  async removeUser(userId: string) {
    return await RNZoomVideoSdkUserHelper.removeUser(userId);
  }
}
